import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { tdsActions } from './tdsRedux/tds.actions';
import { backgroundTdsArr } from './backgroundTdsArr';
import { navigateAction } from '../../helpers/navigationHelpers';
import BackGroundGenerator from '../LandingPages/common/BackGroundGenerator';
import { Container, LineSaperator, ButtonWrapper, BlueBox, BoxShadow, Typography, primaryColor } from './style';
import { ODSText } from '../../../openbrix-design-system/ui/atoms/ODSText';
import { useTheme } from '@emotion/react';
import ODSButton from '../../../openbrix-design-system/ui/atoms/ODSButton/index.native';
import Constant from './tdsRedux/Constant';
import { useRoute } from '@react-navigation/native';

const custodialChangePassword = (props) => {
  const dispatch = useDispatch();
  const [type, setType] = useState('web');
  const {colors}=useTheme();
  const tdsLocationSelected = useSelector((state) => state.appReducer?.tdsLocationSelected);
  const routes=useRoute();
  const profile = useSelector((state) => state.authReducer?.profile?.data);
  const tdsForgotPasswordLink = tdsLocationSelected === 'TDS_NI'
    ? profile?.tdsForgotPasswordLinkNI
    : tdsLocationSelected === 'TdsScoctland'
      ? profile?.tdsForgotPasswordLinkScotland
      : profile?.tdsForgotPasswordLinkEngland;




  const triggerChangePassword = () => {
    dispatch(tdsActions.triggerResetPassword());
  };

  return (
    <>
      <BackGroundGenerator
        isTds
        props={props}
        paddingtop={80}
        layoutType={(data) => {
          setType(data);
        }}
        isTLYF
        backgroundArr={backgroundTdsArr}
        isBack={true}
        infoIcon
        backNavigation={()=> 
          navigateAction(props.navigation, 'Custodial Account') }
      >
        <Container>
          <BoxShadow>
            <ODSText type='h6' color='#001A96' textAlign='center'>Change Password</ODSText>
            <ODSText marginTop={24} type='sm' color={colors.text.secondary} textAlign='center'>{`Pressing the button below will initiate the password change process. You will be sent an email containing a link to follow.

Upon following this link you will be asked to enter a new password.`}</ODSText>

     <ODSButton
     restStyle={{width:'80%',backgroundColor:'#FF41C0',marginTop:40,alignSelf:'center'}}
     onPress={() => 
     {
 
            window.open(tdsForgotPasswordLink, '_blank') 
        
     }
      }
     >
      Change my password
     </ODSButton>

              {/* <Typography color={primaryColor} size={'23px'} bold={600}>
                Change Password
              </Typography>
            <Typography top={'40px'} color={'#454545'} size={'20px'} bold={400}>
              Pressing the button below will initiate the password change process.
            </Typography>
            <Typography color={'#454545'} size={'20px'} bold={400}>
              You will be sent an email containing a link to follow.
            </Typography>
            <Typography bottom={'30px'} top={'20px'} color={'#454545'} size={'20px'} bold={400}>
              Upon following this link you will be asked to enter a new password.
            </Typography>
            <LineSaperator />
            <ButtonWrapper 
            id={"TDS_CHANGE_MY_PASS"}
            top={'40px'} onPress={() => triggerChangePassword()}>
              <Typography 
               id={"TDS_CHANGE_MY_PASS_TEXT"}
              color={'#FFFFFF'} size={'19px'} bold={700}>
                CHANGE MY PASSWORD
              </Typography>
            </ButtonWrapper> */}
          </BoxShadow>
        </Container>
      </BackGroundGenerator>
    </>
  );
};

export default custodialChangePassword;
